<template>

    <div class="page">

        <Top></Top>

        <div class="page-content bottom-sp60">
                
            <div style="height: 100px" class="hidden-xs hidden-md"></div>

            <a class="link back" style="position: absolute; top: 17px; left: 30px;">
                <i class="las la-bars" v-on:click="$root.menu" style="font-size: 30px; color: var(--f7-theme-color-shade);"></i>
            </a>
            
            <div class="container">
                <center class="hidden-xl hidden-lg">
                    <img data-v-c549cbd6="" src="static/images/logo.png" style="width: 50%; margin-top: 50px; margin-bottom: 25px; max-width: 250px;">
                </center>
            </div>
          

            <div class="container">

                <div v-if="$root.user.tipo == 'prestador'  && !$root.user.empresaCod">
                    <h5 v-if="$root.user.confirmacao == 1 && !$root.user.pagamentoId" style="color: #e42700; display: block; line-height: 130%; font-weight: 300; margin-top: 10px; margin-bottom: 10px;">
                        <i class="las la-exclamation-triangle"></i>
                        Você precisa cadastrar sua conta bancária para começar a trabalhar.
                    </h5>
                    <h5 v-if="$root.user.confirmacao == 0" style="color: #e42700; display: block; line-height: 130%; font-weight: 300; margin-top: 10px; margin-bottom: 25px;">
                        <i class="las la-exclamation-triangle"></i>
                        Seu <b style="font-weight: 600;">cadastro está em análise</b> pela nossa equipe. Você <b style="font-weight: 600;">receberá</b> uma <b style="font-weight: 600;">notificação</b> quando tudo estiver pronto para começar a <b style="font-weight: 600;">trabalhar</b>.
                    </h5>
                    <h5  v-if="$root.user.confirmacao == -1" style="color: #e42700; display: block; line-height: 130%; font-weight: 300; margin-top: 10px; margin-bottom: 25px;">
                        <i class="las la-exclamation-triangle"></i>
                        Infelizmente seu cadastro foi negado pela nossa equipe. Entre em contato caso tenha dúvidas.
                    </h5>
                    <button v-if="$root.user.confirmacao == 1 && !$root.user.pagamentoId" v-on:click="$root.go('Carteira')" type="button" class="button button-fill button-large color-green block-mobile " style="margin-bottom: 28px">
                        <i class="las la-money-bill-wave"></i>
                        Cadastrar dados bancários
                    </button>                                                                
                </div>
            </div>
<!-- 
            <div class="container" v-if="$root.user.tipo == 'empresa'">
                <div class="title-bar mt-40">
                    <h5 class="dz-title">Área da empresa</h5>
                </div>
                <div class="mb-30 row grouped-cards">
                    <div style="flex: 1 1 30%;" class="col-100 mb-15" v-on:click="$root.go('PrestadoresEmpresas')">
                        <div class="categories-bx">
                            <img src="static/images/icons/users.png" alt="" class="categories-icon">
                            <h6 class="title">
                                Profissionais
                            </h6>
                        </div>
                    </div>

                </div>
            </div> -->

            <div class="container" v-if="$root.user.tipo == 'prestador'" v-bind:class="{'disabled': ($root.user.confirmacao != 1 || (!$root.user.pagamentoId && !$root.user.empresaCod))}">
                <div class="title-bar">
                    <h5 class="dz-title">Área do profissional</h5>
                </div>
                <div class="mb-30 row grouped-cards">                                                                                                                                                  
                    <div v-if="!$root.user.empresaCod" style="flex: 1 1 30%;" class="col-50 mb-15 click" v-on:click="$root.go('Agendas', JSON.stringify({'voltar': true, 't': Math.random()}))">
                        <div class="categories-bx">
                            <img src="static/images/icons/schedule.png" alt="" class="categories-icon" style="width: 37px;">
                            <h6 class="title">
                                Opções de<br>atendimento  
                            </h6>
                        </div>
                    </div>                                                                                                                                                       
                    <div v-if="!$root.user.empresaCod" style="flex: 1 1 30%;" class="col-50 mb-15 click" v-on:click="$root.go('VisualizarHorarios', JSON.stringify({'t': Math.random()}))">
                        <div class="categories-bx">
                            <img src="static/images/icons/agenda.png" alt="" class="categories-icon" style="width: 42px;">
                            <h6 class="title">
                                Visualizar<br>agenda  
                            </h6>
                        </div>
                    </div>                                                                                                                                                       
                    <div style="flex: 1 1 30%;" class="col-50 mb-15 click" v-on:click="$root.go('Pedidos', JSON.stringify({'t': Math.random()}))">
                        <div class="categories-bx">
                            <img src="static/images/icons/times.png" alt="" class="categories-icon" style="width: 38px;">
                            <h6 class="title">
                                Meus<br>pedidos  
                            </h6>
                        </div>
                    </div>   
                    <div style="flex: 1 1 30%;" class="col-50 mb-15 click" v-on:click="$root.go('Pacientes', JSON.stringify({'t': Math.random()}))">
                        <div class="categories-bx">
                            <img src="static/images/icons/users.png" alt="" class="categories-icon" style="width: 38px;">
                            <h6 class="title">
                                Meus<br>pacientes  
                            </h6>
                        </div>
                    </div>                                                                                                                                                                           
                    <div v-if="!$root.user.empresaCod" style="flex: 1 1 30%;" class="col-50 mb-15 click" v-on:click="$root.go('Informacoes', JSON.stringify({'t': Math.random()}))">
                        <div class="categories-bx">
                            <img src="static/images/icons/infos.png" alt="" class="categories-icon">
                            <h6 class="title">
                                Informações<br>gerenciais  
                            </h6>
                        </div>
                    </div>                                                                                                                                                                                                                                                                                     
                    <div v-if="!$root.user.empresaCod" style="flex: 1 1 30%;" class="col-50 mb-15 click" v-on:click="$root.go('Carteira', JSON.stringify({'t': Math.random()}))">
                        <div class="categories-bx">
                            <img src="static/images/icons/bank.png" alt="" class="categories-icon">
                            <h6 class="title">
                                Dados<br>bancários  
                            </h6>
                        </div>
                    </div>                                                                                                                                                       
                    <div v-if="!$root.user.empresaCod" style="flex: 1 1 30%;" class="col-50 mb-15 click" v-on:click="$root.go('Cupons')">
                        <div class="categories-bx">
                            <img src="static/images/icons/discount.png" alt="" class="categories-icon" style="width: 4px;">
                            <h6 class="title">
                                Cupons de<br>desconto
                            </h6>
                        </div>
                    </div>
                    <div class="col-50 mb-15" style="flex: 1 1 30%;"  v-on:click="$root.go('Contato')">
                        <div class="categories-bx">
                            <img src="static/images/icons/contact.png" alt="" class="categories-icon" style="width: 38px;">
                            <h6 class="title">
                                Fale<br>conosco  
                            </h6>
                        </div>                                                                                                                                   
                    </div>                    
                </div>
            </div>


            <div class="container" v-if="$root.user.tipo == 'empresa'">
                <div class="title-bar mt-40">
                    <h5 class="dz-title">Área da empresa</h5>
                </div>
                <div class="mb-30 row grouped-cards">                  
                    <div style="flex: 1 1 30%;" class="col-50 mb-15 click" v-on:click="$root.go('PrestadoresEmpresas')">
                        <div class="categories-bx">
                            <img src="static/images/icons/health.png" alt="" class="categories-icon">
                            <h6 class="title">
                                Profissionais
                            </h6>
                        </div>
                    </div>     
                    <div class="col-50 mb-15" style="flex: 1 1 30%;"  v-on:click="$root.go('Contato')">
                        <div class="categories-bx">
                            <img src="static/images/icons/contact.png" alt="" class="categories-icon" style="width: 38px;">
                            <h6 class="title">
                                Fale<br>conosco  
                            </h6>
                        </div>                                                                                                                                   
                    </div>                                                       
                </div>
            </div>


            <div class="container" v-if="$root.user.tipo == 'admin'">
                <div class="title-bar mt-40">
                    <h5 class="dz-title">Área de administração</h5>
                </div>
                <div class="mb-30 row grouped-cards">
                    <div style="flex: 1 1 30%;" class="col-50 mb-15 click" v-on:click="$root.go('Pacientes')">
                        <div class="categories-bx">
                            <img src="static/images/icons/users.png" alt="" class="categories-icon">
                            <h6 class="title">
                                Pacientes
                            </h6>
                        </div>
                    </div>                    
                    <div style="flex: 1 1 30%;" class="col-50 mb-15 click" v-on:click="$root.go('Profissionais')">
                        <div class="categories-bx">
                            <img src="static/images/icons/health.png" alt="" class="categories-icon">
                            <h6 class="title">
                                Profissionais
                            </h6>
                        </div>
                    </div>
                    <div style="flex: 1 1 30%;" class="col-50 mb-15 click" v-on:click="$root.go('Pedidos', JSON.stringify({'t': Math.random()}))">
                        <div class="categories-bx">
                            <img src="static/images/icons/agenda.png" alt="" class="categories-icon" style="width: 42px;">
                            <h6 class="title">
                                Pedidos
                            </h6>
                        </div>
                    </div>
                    <div style="flex: 1 1 30%;" class="col-50 mb-15 click" v-on:click="$root.go('Configuracoes')">
                        <div class="categories-bx">
                            <img src="static/images/icons/cog.png" alt="" class="categories-icon">
                            <h6 class="title">
                                Configurações
                            </h6>
                        </div>
                    </div>
                    <div style="flex: 1 1 30%;" class="col-50 mb-15 click" v-on:click="$root.go('Profissoes', JSON.stringify({'t': Math.random()}))">
                        <div class="categories-bx">
                            <img src="static/images/icons/cog.png" alt="" class="categories-icon">
                            <h6 class="title">
                                Profissões
                            </h6>
                        </div>
                    </div>
                    <div style="flex: 1 1 30%;" class="col-50 mb-15 click" v-on:click="$root.go('Especialidades', JSON.stringify({'t': Math.random()}))">
                        <div class="categories-bx">
                            <img src="static/images/icons/cog.png" alt="" class="categories-icon">
                            <h6 class="title">
                                Especialidades
                            </h6>
                        </div>
                    </div>
                    <div style="flex: 1 1 30%;" class="col-50 mb-15 click" v-on:click="$root.go('Avaliacoes')">
                        <div class="categories-bx">
                            <img src="static/images/icons/ratings.png" alt="" class="categories-icon">
                            <h6 class="title">
                                Avaliações
                            </h6>
                        </div>
                    </div>
                    <div style="flex: 1 1 30%;" class="col-50 mb-15 click" v-on:click="$root.go('Cupons')">
                        <div class="categories-bx">
                            <img src="static/images/icons/discount.png" alt="" class="categories-icon" style="width: 4px;">
                            <h6 class="title">
                                Cupons de<br>desconto
                            </h6>
                        </div>
                    </div>
                    <div style="flex: 1 1 30%;" class="col-50 mb-15 click" v-on:click="$root.go('Empresas')">
                        <div class="categories-bx">
                            <img src="static/images/icons/business-and-trade.png" alt="" class="categories-icon" style="width: 4px;">
                            <h6 class="title">
                                Empresas
                            </h6>
                        </div>
                    </div>    
                    <div style="flex: 1 1 30%;" class="col-50 mb-15 click" v-on:click="$root.go('Usuarios')">
                        <div class="categories-bx">
                            <img src="static/images/icons/workers.png" alt="" class="categories-icon">
                            <h6 class="title">
                                Usuários
                            </h6>
                        </div>
                    </div>                                    
                </div>
            </div>

            <div class="container hidden-xl hidden-lg">
                <div class="mt-15 mb-30" v-bind:class="{'disabled': $root.user.confirmacao != 1}" v-if="$root.user.tipo == 'prestador'  && !$root.user.empresaCod" style="position: relative; width: 100%; max-width: 100%;">
                    <div class="carteira-conta">
                        <center>
                            <p class="title">
                                <i class="las la-money-bill"></i>
                                Carteira digital
                            </p>
                            <h1 style="color: #fff; margin: 0px; display: block; width: 100%;">
                                <b>R$ {{saldo.AmountAvailableToday | toMoney }}</b>
                            </h1>
                            <p style="margin: 0px; color: #fff;  font-size: 14px; display: block; width: 100%;">
                                Saldo a liberar:&nbsp;&nbsp;<b>R$ {{saldo.AmountPreviewTotal | toMoney }}</b>
                            </p>   

                            <div style="height: 1px; width: 100%; display: block;">
                                
                            </div>

                            <button v-bind:class="{'disabled': saldo.AmountAvailableToday == 0}" v-on:click="sacar()" class="button-outline button button-medium color-white mb-5">
                                Sacar valor disponível
                            </button>                                                                 

                            <a v-on:click="$root.go('Saques')" style="text-decoration: underline; color: #fff; font-size: 12px; display: block; margin-top: 0px; opacity: 0.7;">
                                Extrato de recebimentos e saques
                            </a>
                        </center>
                    </div>                            
                </div>
            </div>
        </div>
        
        <Toolbar></Toolbar>
        
    </div>
</template>

<script>
import Top      from './Top'
import Toolbar  from './Toolbar'
var self = this;
export default {
    name: 'Inicio',
    components: {
        'Top':                      Top,
        'Toolbar':                  Toolbar
    },        
    data () {
        return {
            "filtro":               false,
            "saldo": {
                "AmountAvailableToday":0,
                "AmountPreviewTotal": 0
            },                   
            "categorias": {
                "itens":            []
            },
            "galeria": {
                "itens":            []
            },    
            "data": {
                "itens":            []
            },                        
            "form": {
                "tipo":             "catalogo",
                "page":             1,
                "distancia":        "",
                "profissao":        "",
                "especialidade":    "",
                "servico":          "",
                "tipo":             "",
                "pesquisa":         ""
            },
        }
    },
    filters: {     
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2});
            } else {
                return "0,00";
            }
        },        
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }
            return date + (time ? (" " + time) : "");
        }
    },     
    methods: {
        getBase64Imagem: function(event) {
            var self            = this;
            if (event.target.files[0]) {
                loading.show();
                reduceFileSize(event.target.files[0], 500*1024, 800, Infinity, 0.6, blob => {
                    blobToBase64(blob, function(result) {
                        setTimeout(function() {
                            loading.hide();
                        }, 500);
                        self.form[event.target.id.split("-")[2]]    = result;
                    });
                }); 
            } else {
                setTimeout(function() {
                    loading.hide();
                }, 500);                
            } 
        },         
        delGaleria: function(cod) {
            console.log("delGaleria()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar esse item?", function() {

                var form            = {};
                form._cod           = self.$root.user.cod;
                form._token         = self.$root.user.token;
                form.cod                = cod;
                loading.show();
                
                axios.delete("api/galeria.php", {params: form})
                .then(response => {
                    console.log("delGaleria() response", response)
                    self.getGaleria().finally(function() {
                        loading.hide();
                    });
                })
                .catch(error => {
                    console.log("delGaleria() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },
        menu: function() {
            var self = this;
            console.log("menu");
            window.___app.dialog.create({
                title: 'Osis',
                text: '',
                buttons: [
                    {
                        text: 'Minha conta',
                        onClick: function() {
                            self.$root.go("Conta");
                        }
                    },
                    {
                        text: 'Alterar senha',
                        onClick: function() {
                            self.$root.go("AlterarSenha");
                        }
                    },             
                    {
                        text: 'Fale conosco',
                        onClick: function() {
                            self.$root.go("Contato");
                        }
                    },
                    {
                        text: 'Termos de uso',
                        onClick: function() {
                            loading.show();
                            setTimeout(function() {
                                self.$root.openModal('modal-termos-de-uso');
                            }, 500);
                        }
                    },      
                    {
                        text: 'Políticas de privacidade',
                        onClick: function() {
                            loading.show();
                            setTimeout(function() {
                                self.$root.openModal('modal-politicas-de-privacidade');
                            }, 500);
                            
                        }
                    },   
                    {
                        text: 'Deslogar',
                        onClick: function() {
                            self.$root.logout();
                        }
                    },                                                            
                    {
                        text: '<span style="color: red; font-weight: 200">Voltar<span>',
                    },                                                            
                ],
                verticalButtons: true,
            }).open();            
        },
        mostrarFiltro: function() {
            var self = this;
            self.filtro = (self.filtro ? false : true);
            self.$forceUpdate();
        },
        sacar: function() {
            var self    = this;

            var form            = {};
            form._cod           = self.$root.user.cod;
            form._token         = self.$root.user.token;
            form.acao           = "sacar";
            loading.show();
            
            axios.put("api/carteira.php", form)
            .then(response => {
                console.log("renovar() responde", response.data);
                alert(response.data.message);
                self.getSaldo().finally(function() {
                    loading.hide();
                });
            })
            .catch(error => {
                console.log("renovar() error", error)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                                
            });  
        },          
        getSaldo: function() {
            // console.log("getSaldo()");
            var self = this;
            return new Promise(function(resolve, reject) {

                if (self.$root.user.tipo != "prestador") {
                    return resolve(true);
                }

                var form            = {};
                form._cod           = self.$root.user.cod;
                form._token         = self.$root.user.token;
                form.tipo           = "saldo";

                axios.get("api/carteira.php", {"params": form})
                .then(response => {
                    
                    console.log("getSaldo() response", response);
                    self.saldo      = response.data.result;
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getSaldo() error", error);

                    resolve(error);
                    // alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    
                }); 
            }); 

        },            
        getCategorias: function() {
            var self        = this;
            console.log("getCategorias()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        // "filtro":       "destaque"
                    }
                };

                if (self.$root.cache.categorias.data) {
                    self.categorias   = JSON.parse(JSON.stringify(self.$root.cache.categorias.data));
                    resolve(self.categorias);
                    
                } else {
                    
                    axios.get("api/categorias.php", form)
                    .then(response => {
                        
                        console.log("getCategorias() response", response);
                        self.categorias                     = response.data.result;

                        setTimeout(function() {
                            var swiper = new Swiper('.categories-swiper', $(".categories-swiper").data());
                        }, 100);

                        self.$root.cache.categorias.data    = JSON.parse(JSON.stringify(response.data.result));
                        // loading.hide();
                        resolve(response.data.result);
      
                    })
                    .catch(error => {
                        console.log("getCategorias() error", error);                    
                        // loading.hide();
                        reject(error);
                        alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                        if (error.response) {
                            if (error.response.status == 404) {
                                self.$root.back();
                            }
                        }                    
                    });   
                }
            });   
        },   
        getGaleria: function() {
            var self        = this;
            console.log("getGaleria()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token
                    }
                };

                axios.get("api/galeria.php", form)
                .then(response => {
                    
                    console.log("getGaleria() response", response);
                    self.galeria                     = response.data.result;
                    // self.$root.cache.inicioPrestadores.data    = JSON.parse(JSON.stringify(response.data.result));
                    // loading.hide();

                    self.$forceUpdate();

                    setTimeout(function() {
                        var swiper = new Swiper('.galeria-swiper', $(".galeria-swiper").data());
                    }, 500);                    
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getGaleria() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                                    
                });   

            });   
        },                       
        get: function(load) {
            var self        = this;
            
            console.log("get()", self.form, load);
            self.$root.go("Busca", JSON.stringify({
                "pesquisa":         self.form.pesquisa, 
                "profissao":        self.form.profissao, 
                "distancia":        self.form.distancia, 
                "tipo":             self.form.tipo, 
                "especialidade":    self.form.especialidade, 
            }));

        },          
    },
    created: function() {
        loading.show();
        var self = this;

        if (!window.__app.mobile.isMobile) {
        // if (!window.__app.mobile.isMobile || self.$root.user.tipo == "empresa" || (self.$root.user.tipo == "prestador" && self.$root.user.empresaCod)) {
            self.$root.go("Conta");
            return false;
        } else {
            setTimeout(function() {
                self.$root.getPasso();                        
            }, 3000);
        }
    },
    activated: function() {
        var self = this;
        var load = true;

        if (!window.__app.mobile.isMobile) {
        // if (!window.__app.mobile.isMobile || self.$root.user.tipo == "empresa" || (self.$root.user.tipo == "prestador" && self.$root.user.empresaCod)) {
            self.$root.go("Conta");
            return false;
        }

        self.$root.cache.catalogo = {
            "filtro":   null,
            "data":     null,
        };

        self.$root.$forceUpdate();

        loading.show();
        Promise.resolve()
        .then(self.getCategorias())
        // .then(self.getGaleria())
        .then(self.getSaldo())
        .finally(function() {

            console.log("Buscou tudo")
            setTimeout(function() {
                self.$forceUpdate();
                self.$root.$forceUpdate();
                setTimeout(function() {
                    loading.hide();
                }, 1000);
            }, 500);

        });
    },
    mounted: function() {
        var self = this;
        setTimeout(function() {
            if ($(".user-swiper").length > 0) {
                var swiper = new Swiper('.user-swiper', $(".user-swiper").data());
            }
            var swiper = new Swiper('.categories-swiper', $(".categories-swiper").data());
            var swiper = new Swiper('.pro-swiper', $(".pro-swiper").data());
            var swiper = new Swiper('.catalogo-swiper', $(".catalogo-swiper").data());
        }, 500);
        setTimeout(function() {
            // loading.hide();
            // self.$root.go("Conta");
        }, 1000);
    }   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
    .tag-list {
        margin-bottom: 0px !important;
        margin-top: 0px;
    }

    .item-title {
        font-weight: 500;
        margin-bottom: 0px !important;
        line-height: 130%;
    }
    .chip-label {
        font-weight: bold;
        font-size: 12px !important;
    }
    .chip {
        line-height: 18px !important;
        height: auto !important;
        min-height: 18px !important;
        /*padding-bottom: 0px;*/
        /*padding-top: 0px;*/
        margin-top: -4px;
        margin-left: -2px;
        margin-bottom: 5px;
    }
    .dz-media {
        margin-bottom: 5px !important;
        padding-bottom: 0px !important;
    }
    .tabbar.tab-style-2 .tab-link:after {
        display: none !important;
    }

    .avatar-empresa {
        margin: 0px !important;
        /*width: 100px;*/
    }

    .pro-swiper .dz-info {
        width: 100%;
    }

    .pro-swiper .dz-meta {
        margin-top: 0px;
    }

    .avatar-empresa img {
        float: right;
        width: 100px;
        border-radius: 10px;
        /*border: 1px solid #ddd;*/
    }

    .banner {
        width: 100%;
        height: 147px;
        background-color: #efefef;
        border-radius: 10px;
        line-height: 150px;
        vertical-align: middle;
        text-align: center;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        border: 1px solid #efefef;
    }

    .swiper-slide.add {
        /*margin-right: -10px !important;*/
    }

    .swiper-slide.add span {
        line-height: 130%;
        display: inline-block;
        position: relative;
        top: 10px;
        color: #333;
        font-weight: bold;        
    }

    .banner .uploadButton {
        width: 100%;
        height: 100%;
    }

    .banner .uploadButton label {
        width: 100%;
        height: 100%;
    }    

    .banner .uploadButton-input {
        visibility: hidden;
        position: absolute;
        left: -99999999px;
    }    

    .banner .button i {
        margin: 0px !important;
    }

    .banner .button {
        position: absolute;
        right: 10px;
        padding: 0px;
        text-align: center;
        font-size: 20px;
        top: 10px;
        width: 25px;
    }

    .categorias {
        background: #f9f9f9;
        padding-top: 30px;
        padding-bottom: 30px;
        border-top: 1px solid #ddd;
        margin-top: 45px;
    }

    .categorias .categories-bx {
        height: 50px;
        padding: 2% 15%;
        display: flex;
        display: -webkit-flex;
        -webkit-flex-direction: row;
        flex-direction: row;
        align-content: center;
        -webkit-align-content: center;
        align-items: center;
        -webkit-align-items: center;
    }

    .categorias .categories-bx .title {
        text-align: center;
        margin-bottom: 0px;
        width: 100%;
    }

    .categorias .categories-bx .title a {
        color: #FFF;
        font-size: 14px;
    }

    .searchbar .searchbar-input-wrap {
        height: 50px;
    }

    .searchbar .searchbar-input-wrap input {
        font-size: 14px;
        padding: 0p 40px 0 15px;
    }

    .searchbar .searchbar-input-wrap a {
        left: auto !important;
        position: absolute;
        color: var(--f7-theme-color) !important;
        right: 15px !important;
        top: 15px !important;
        z-index: 99;
        height: 20px;
        width: 20px;
    }

    .searchbar .searchbar-input-wrap a i {
        width: 20px;
        height: 20px;
        position: static;
        margin-top: 0px;
        left: 0px;
        top: 0px;
    }
    
    .searchbar-icon:after {
        content: none;
    }

    .searchbar input[type='text'], .searchbar input[type='search'] {
        border-radius: 32px;
        padding: 0 15px;
    }

    .grouped-cards {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .grouped-cards .categories-bx {
        height: 85px;
        padding: 5vw;
        display: flex;
        justify-content: center;
        /*justify-content: space-between;*/
        align-items: flex-start;
        flex-direction: column;
    }

    .grouped-cards .categories-bx .title {
        font-size: 16px;
        margin: 0px;
        font-weight: 400;
    }

    .profile-buttons {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
    }

    .profile-info button {
        width: auto;
        margin-top: 10px;
        opacity: 1;
    }

    .profile-content p span {
        opacity: 0.75;
        letter-spacing: 0.5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Inicio.vue